var map = {
	"./ai.ts": 3018,
	"./article.ts": 7444,
	"./audit-doctor.ts": 3665,
	"./audit-patient.ts": 9349,
	"./chat.ts": 7262,
	"./coupon.ts": 1097,
	"./form.ts": 7962,
	"./index.ts": 4950,
	"./jsonform.ts": 9668,
	"./log.ts": 8268,
	"./patient.ts": 8371,
	"./project.ts": 8315,
	"./renwumingxi.ts": 5833,
	"./ruzuxingwei.ts": 1717,
	"./shujumingxi.ts": 8951,
	"./team.ts": 6473,
	"./xiangmu.ts": 9745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2427;